import { useRouter } from 'next/router'

import {
  SubtitleContainer,
  SimilarProjectsContainer,
  SimilarProjectListWrapper,
  SimilarProjectImageContainer,
  SimilarProjectItemContainer,
  Title,
  Subtitle,
  ImageFrame,
  ImageBackground,
  FrameAndBackgroundWrapper,
  ProjectTitle,
  ProjectDescription,
  ProjectImage,
  ProjectImageWrapper,
} from './styled'

import Container from '../../Container'
import Loading from './Loading'
import Button from 'components/Button'

import { SimilarProjectsProps } from './types'

import backgroundFrame from '../../../public/assets/similar-projects/frame.webp'

const SimilarProjects = ({ similarProjects, isFetching }: SimilarProjectsProps) => {
  const router = useRouter()

  if (!similarProjects && !isFetching) return null

  return (
    <SimilarProjectsContainer>
      <Container>
        <Title>Similar Projects</Title>
        <SubtitleContainer>
          <Subtitle>Check out some of our similar projects.</Subtitle>
          <Button
            showicon="true"
            buttonvariant="outlined"
            onClick={() => router.push('/portfolio')}
          >
            View all
          </Button>
        </SubtitleContainer>
        <SimilarProjectListWrapper>
          {isFetching || !similarProjects ? (
            <Loading />
          ) : (
            similarProjects.map((project: ISimilarProject, index: number) => (
              <SimilarProjectItemContainer key={index}>
                <SimilarProjectImageContainer
                  onClick={() => router.push(`/portfolio/${project.slug}`)}
                >
                  <ProjectImageWrapper>
                    <ProjectImage
                      src={project?.logo?.fullSize}
                      alt={project?.slug}
                      layout="fill"
                      objectFit="scale-down"
                    />
                  </ProjectImageWrapper>
                  <FrameAndBackgroundWrapper>
                    <ImageFrame src={backgroundFrame} alt="frame" layout="fill" />
                    <ImageBackground sx={{ backgroundColor: project.primaryColor }} />
                  </FrameAndBackgroundWrapper>
                </SimilarProjectImageContainer>

                <ProjectTitle onClick={() => router.push(`/portfolio/${project.slug}`)}>
                  {project?.title}
                </ProjectTitle>
                <ProjectDescription>{project?.tagline}</ProjectDescription>
              </SimilarProjectItemContainer>
            ))
          )}
        </SimilarProjectListWrapper>
      </Container>
    </SimilarProjectsContainer>
  )
}

export default SimilarProjects
